import { render, staticRenderFns } from "./ReviewRentKebabFilter.vue?vue&type=template&id=4afb60ca&"
import script from "./ReviewRentKebabFilter.vue?vue&type=script&lang=js&"
export * from "./ReviewRentKebabFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports